import { useParams, Link } from "react-router-dom";

export default function Service() {
  const { name } = useParams();

  return (
    <div className="p-10 text-white">
      <h1 className="text-4xl mb-6">{name}</h1>

      <p className="text-gray-400 mb-6">
        Book professional {name} services near you.
      </p>

      <Link to="/booking">
        <button className="bg-blue-500 px-6 py-3 rounded-xl">
          Book Now
        </button>
      </Link>
    </div>
  );
}